<template>
	<div class="flex w-full align-middle items-center odd:bg-gray-200 pt-4 px-4 space-x-4">
		<div class="mb-4 font-bold w-16 mr-2">{{ index + 1 }}</div>
		<BaseDatepicker ref="BaseDatePicker" v-model="date" class="w-1/8" placeholder="Datum" @change="emitDate" />
		<BaseInput
			ref="BaseInput.time"
			v-model="task.time"
			:mask="['N:NN', 'NN:NN']"
			class="w-1/8"
			maxlength="5"
			:placeholder="$t('time')"
			validationtype="time"
			@input="emitDate()"
		/>
		<BaseInput v-model="task.name" class="flex-grow" maxlength="80" ref="name" @change="$emit('change')" />
		<div class="form-group" style="text-align: center">
			<font-awesome-icon
				:icon="['fa', 'trash-alt']"
				class="cursor-pointer md:w-4 lg:text-lg md:text-xl w-auto text-grey-200 hover:text-red-300 lg:mt-0 md:mt-0 mt-4 mx-4"
				:title="$t('delete').toString()"
				@click="deleteTask"
			></font-awesome-icon>
		</div>
	</div>
</template>
<script>
import BaseDatepicker from '@/components/forms/inputs/BaseDatepicker';
import BaseInput from '@/components/forms/inputs/BaseInput';
import apiDefaults from '@/api/defaultConfiguration';
import { RepairplanApiFactory } from '@/api/generated';

export default {
	name: 'RepairPlanRow',
	components: { BaseInput, BaseDatepicker },
	props: {
		task: {},
		index: {},
		repairPlan: {},
	},
	computed: {
		date: {
			get() {
				return new Date(this.task.date * 1000);
			},
			set(v) {
				this.emitDate(v);
			},
		},
	},
	methods: {
		emitDate(v) {
			if (!v) v = this.date;
			let minutes = 0;
			let hours = 0;

			if (this.task.time && v && this.$refs['BaseInput.time'].isValueValid(this.task.time)) {
				const time = this.task.time.split(':');
				hours = parseInt(time[0]);
				minutes = parseInt(time[1]);
			}

			v.setHours(hours);
			v.setMinutes(minutes);

			this.$emit('update:date', v.getTime() / 1000);
			this.$emit('change');
		},
		deleteTask() {
			this.$swal({
				title: this.$t('sure').toString(),
				text: this.$t('delete_entry').toString(),
				icon: 'warning',
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
			}).then(result => {
				if (result.value) {
					if (this.task.id) {
						RepairplanApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
							.repairPlanRepairPlanIdRepairPlanRowIdDelete(this.repairPlan.id, this.task.id)
							.then(response => {
								this.$emit('delete');
							});
					} else {
						this.$emit('delete');
					}
				}
			});
		},
	},
};
</script>
